const setDepartmentName = (department) => {
  switch (department) {
    case "arem":
      return "Arctic Real Estate Management AS";
    case "asec":
      return "Arctic Securities AS";
    default:
      return "Arctic Securities AS";
  }
}

export const appVersion = process.env.REACT_APP_APP_VERSION || "latest"

// Department/company info
export const department = {
  name: setDepartmentName(process.env.REACT_APP_DEPARTMENT || "asec"),
  shortName: (process.env.REACT_APP_DEPARTMENT || "asec").toUpperCase()
}
